/* src/app/private/components/view/campus/delete-campus/delete-campus.component.scss */
/*# sourceMappingURL=delete-campus.component.css.map */
